var _path, _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongratulationsBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1089,
    height: 240,
    fill: "none",
    viewBox: "0 0 1089 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 0H1089V240H1z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "o73vqux6xa",
    width: 1088,
    height: 240,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H1088V240H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o73vqux6xa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M-140.61 353.305C-41.796 583.548 79.118 531.127 114.3 456.241c35.309-75.013 97.036-72.094 161.303-86.944 81.922-19.039 123.454-118.422 43.184-183.915-67.824-55.34-177.307-36.809-197.755-143.045C89.025-124.19-83.582-149.83-140.61-33.184c-49.28 100.652-42.294 287.994 0 386.489z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M1216.61-168.305C1117.8-398.548 996.882-346.127 961.7-271.241c-35.309 75.013-97.036 72.094-161.303 86.944C718.475-165.258 676.943-65.876 757.213-.382c67.824 55.34 177.307 36.809 197.755 143.045 32.007 166.527 204.612 192.166 261.642 75.521 49.28-100.652 42.29-287.994 0-386.489z",
    opacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -129.239,
    x2: 190.36,
    y1: -121.563,
    y2: 443.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27BDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1205.24,
    x2: 885.64,
    y1: 306.563,
    y2: -258.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27BDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF933"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulationsBg);
export default __webpack_public_path__ + "static/media/congratulations_bg.1e9b2043a143ee4500757e712f0ce0e5.svg";
export { ForwardRef as ReactComponent };